<template>
  <v-layout>
    <v-flex lg6 offset-lg3>
      <jti-expansion-panel panelName="Master Card Details">
        <v-container class="pa-2">
          <v-layout row wrap>
            <v-flex lg12>
              <v-form ref="formMasterCard">
                <v-text-field
                  v-if="readonly"
                  v-model="data.company_name"
                  label="Company"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  v-if="!readonly"
                  v-model="assignCompany"
                  :items="companies"
                  label="Select Company"
                  required
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  v-if="readonly"
                  v-model="data.sub_company_name"
                  label="Subcompany"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  v-if="!readonly"
                  v-model="assignSubCompany"
                  :items="subCompanies"
                  label="Select Sub Company"
                  required
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  v-if="readonly"
                  v-model="data.terminal_name"
                  label="Terminal"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  v-if="!readonly"
                  v-model="assignTerminal"
                  :items="terminals"
                  label="Select Terminal"
                  required
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  v-if="readonly"
                  v-model="data.device_name"
                  label="Device Serial"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  v-if="!readonly"
                  v-model="assignDevice"
                  :items="devices"
                  label="Device Serial (Optional)"
                  clearable
                ></v-select>
                <v-text-field
                  v-if="readonly"
                  v-model="data.card_no"
                  label="Master Card No."
                  :readonly="readonly"
                ></v-text-field>
                <v-text-field
                  v-if="!readonly"
                  v-model="cardNo"
                  mask="####-####-####-####"
                  label="Master Card No."
                  required
                  counter="16"
                  maxlength="16"
                  v-on:keypress="isNumber($event)"
                  :rules="[rules.required, rules.counter]"
                ></v-text-field>
                <v-text-field
                  v-if="!readonly"
                  v-model="data.load_allocation"
                  label="Load Allocation"
                  required
                  :rules="[rules.required]"
                  counter="16"
                  maxlength="16"
                  v-on:keypress="isNumber($event)"
                ></v-text-field>
                <v-text-field
                  v-if="readonly"
                  v-model="data.master_contact_name"
                  label="Contact Name"
                  :readonly="readonly"
                ></v-text-field>
                <v-select
                  v-if="!readonly"
                  v-model="assignContact"
                  :items="contacts"
                  label="Contact Name"
                  required
                  :rules="[rules.required]"
                ></v-select>

                <!-- <v-text-field
v-model="data.contact_no"
label="Contact Number"
readonly
></v-text-field> -->
                <v-text-field
                  v-model="contactNo"
                  label="Contact Number"
                  readonly
                ></v-text-field>
                <v-text-field
                  v-if="!readonly"
                  v-model="data.merchant_assignment"
                  label="Merchant Assignment"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </jti-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import Services from "@/services/Services";

export default {
  props: {
    data: Object,
    readonly: Boolean,
    // contacts: {
    // type: Array,
    // default: () => [],
    // },
    // devices: {
    // type: Array,
    // default: () => [],
    // },
    companies: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      // assignContact: this.data.company_mastercard_contact_id,
      assignContact: "",
      assignDevice: this.data.device_id,
      assignCompany: "",
      assignSubCompany: "",
      assignTerminal: "",
      contactNo: "",
      subCompanies: [],
      terminals: [],
      devices: [],
      contacts: [],
      cardNo: "",
    };
  },
  created: function() {
    if (this.data.company_id) {
      this.assignCompany = this.data.company_id;
      this.assignSubCompany = this.data.sub_company_id;
      this.assignTerminal = this.data.terminal_id;
      this.assignContact = this.data.company_mastercard_contact_id;
      this.contactNo = this.data.contact_no;
      this.cardNo = this.data.card_no;
    }
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        company_id: this.assignCompany,
        sub_company_id: this.assignSubCompany,
        terminal_id: this.assignTerminal,
        company_mastercard_contact_id: this.assignContact,
        card_no: this.cardNo,
        device_id: this.assignDevice,
        load_allocation: this.data.load_allocation,
        merchant_assignment: this.data.merchant_assignment,
      };
    },
  },
  watch: {
    assignCompany: async function() {
      if (this.assignCompany) {
        await this.setSubCompanies();
        await this.setTerminals();
      }
    },
    assignSubCompany: async function() {
      if (this.assignCompany) {
        await this.setContact();
      }
    },
    assignContact: async function() {
      if (this.assignContact) {
        await this.setContactPreview();
      }
    },
  },
  methods: {
    validateForm() {
      return this.$refs.formMasterCard.validate();
    },
    resetForm() {
      this.$refs.formMasterCard.reset();
    },
    async setSubCompanies() {
      this.subCompanies = [];
      const items = (
        await Services.getSubCompanies({
          project_id: this.$store.state.employee.project_id,
          company_id: this.assignCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.subCompanies.push(data);
      }
    },
    async setTerminals() {
      this.terminals = [];
      const items = (
        await Services.getTerminals({
          company_id: this.assignCompany,
          sub_company_id: this.assignSubCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.terminals.push(data);
      }
    },
    async setDevices() {
      this.devices = [];
      const items = (
        await Services.getDevices({
          project_id: this.$store.state.project.id,
          company_id: this.assignCompany,
          sub_company_id: this.assignSubCompany,
          terminal_id: this.assignTerminal,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].device_serial.toUpperCase(),
          value: el[i].id,
        };
        this.devices.push(data);
      }
    },
    async setContact() {
      this.contacts = [];

      const items = (
        await Services.getMasterCardContacts({
          sub_company_id: this.assignSubCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text:
            el[i].first_name.toUpperCase() +
            " " +
            el[i].last_name.toUpperCase(),
          value: el[i].id,
        };
        this.contacts.push(data);
      }
    },
    // async setContactPreview() {
    // this.preview_data = {};
    // const items = (await Services.getMasterCardContact(this.assignContact))
    // .data;

    // this.preview_data_contact_no = items.data.contact_no;
    // },
    async setContactPreview() {
      const items = (await Services.getMasterCardContact(this.assignContact))
        .data;

      // this.data.contact_no = items.data.contact_no;

      this.contactNo = items.data.contact_no;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped></style>
